<template>
  <div>
    <div class="w-sidebar-body p-2 mt-3">
      <h4 class="subtitles mt-2 check-text-center">
        MEDICAMENTOS QUE O RESIDENTE EMPRESTOU
      </h4>
    </div>
    <b-overlay :show="loading" opacity="0.99">
      <div
        class="v-clean p-5 text-center mt-2 mb-2"
        v-if="medicines.length == 0"
      >
        <h6 class="text-center upper-text worksansr">SEM RESULTADOS!</h6>
      </div>
      <div v-for="(medicine, key) in medicines" :key="key">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0 pb-0">
          <div class="row b-sidebar-body border-for mb-3 border">
            <div class="col-md-12 check-text-center">
              <h5 class="mb-0 check-text-center">
                {{ medicine.medicine_name }}
              </h5>
              <p class="legends worksansr mb-0 check-text-center">
                {{ medicine.medicine_active_ingredient }}
              </p>
              <div class="d-flex residenttop-content check-text-center">
                <h6
                  class="btn-pendent"
                  v-if="
                    medicine.type_of_recipe_name == 'CONTROLE ESPECIAL - 2 VIAS'
                  "
                >
                  CONTROLE ESPECIAL
                </h6>
              </div>
              <p
                class="
                  warning-alert
                  text-thirteen
                  inline-display
                  mb-0
                  check-text-center
                "
                v-if="
                  medicine.group_prescription_medicine_type == 'LONGO_PRAZO'
                "
              >
                MEDICAMENTO DE PRESCRIÇÃO DE LONGO PRAZO!
              </p>
            </div>
            <div
              class="
                col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12
                bottom-border
              "
              v-for="(item, index) in medicine.items"
              :key="index"
            >
              <div class="row">
                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
                  <p class="m-0 legends worksansr check-text-center">
                    Emprestou para
                  </p>
                  <h6 class="check-text-center">{{ item.resident_name }}</h6>
                </div>
                <div
                  class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12 text-right"
                >
                  <p class="m-0 legends worksansr check-text-center">
                    Total emprestou
                  </p>
                  <h6 class="check-text-center">
                    {{ item.total_was_borrowed }}
                    {{ `${medicine.unit_of_measurement_name} (S)` }}
                  </h6>
                </div>
                <div
                  class="
                    col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12
                    d-flex
                    check-justifique-right
                  "
                >
                  <v-btn
                    v-if="permission('read', 'resident_stock_entry')"
                    class="btn-two-add"
                    @click="handleModalDevolution(item)"
                  >
                    <i class="fas fa-plus mr-2 text-twenty"></i>ADICIONAR
                  </v-btn>
                </div>
              </div>
              <b-modal
                size="lg"
                no-close-on-backdrop
                hide-footer
                :id="`devolution_${item.resident_id}_${item.medicine_check_id}`"
                title="ADICIONAR MEDICAMENTO"
              >
                <div class="row">
                  <div class="col-md-12">
                    <h6>{{ medicine.medicine_name }}</h6>
                    <p class="legends">
                      Residente emprestou {{ item.total_quantity }}
                      {{ `${medicine.unit_of_measurement_name} (S)` }} no total.
                      Informe um valor igual ou abaixo do total.
                    </p>
                  </div>
                  <div v-if="show_stock" class="col-md-12">
                    <div class="row v-clean">
                      <div class="col-md-12 d-flex">
                        <span class="legends">Selecione o estoque do(a) </span>
                        <h6 class="ml-1 mr-1">{{ item.resident_name }}</h6>
                        <span class="legends"
                          >que pegou emprestado para fazer a tranferência.</span
                        >
                      </div>
                      <div class="col-xl-4 col-lg-4 col-md-5 col-sm-12 col-12">
                        <LabelRequiredField label="ESTOQUE DE SAÍDA" />
                        <select
                          v-model="origin_stock_group_id"
                          class="form-control"
                          @change="getLots"
                        >
                          <option value="">SELECIONE...</option>
                          <option
                            v-for="stock in stock_groups"
                            :key="stock.id"
                            :value="stock.id"
                          >
                            {{ stock.name }}
                          </option>
                        </select>
                      </div>
                      <div class="col-xl-8 col-lg-8 col-md-7 col-sm-12 col-12">
                        <LabelRequiredField label="LOTE DO ESTOQUE DE SAÍDA" />
                        <b-overlay :show="loadingLots" opacity="0.99">
                          <div
                            class="c-warning"
                            v-if="stocked_item_lot.length == 0"
                          >
                            <h6>Estoque selecionado não possui lote(s)!</h6>
                          </div>
                          <div class="c-warning" v-if="lot_separate">
                            <h6 class="m-0">
                              EXISTE MEDICAMENTO SEPARADO DO LOTE DO ESTOQUE
                              SELECIONADO, É PRECISO CHECAR OU NÃO SEPARAR O
                              MEDICAMENTO PARA PODER REALIZAR A TRANSFERÊNCIA DO
                              ESTOQUE!
                            </h6>
                          </div>
                          <select
                            v-if="stocked_item_lot.length > 0"
                            v-model="origin_stocked_item_id"
                            class="form-control"
                          >
                            <option value="">SELECIONE...</option>
                            <option
                              v-for="(lot, key) in stocked_item_lot"
                              :key="key"
                              :value="lot.stocked_item_id"
                            >
                              {{ lot.amount }}
                              {{ medicine.unit_of_measurement_abbreviation }} /
                              LOTE: {{ lot.lot }} / VENCIMENTO:
                              {{ formatDateToMonthYear(lot.due_date) }}
                            </option>
                          </select>
                        </b-overlay>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <LabelRequiredField label="FORMA DE DEVOLUÇÃO" />
                    <select
                      @change="handleChangeType($event.target.value)"
                      v-model="type"
                      class="form-control"
                    >
                      <option value="MEDICINE">MEDICAMENTO</option>
                      <option value="MONEY">DINHEIRO</option>
                    </select>
                  </div>
                  <div class="col-md-3">
                    <LabelRequiredField
                      :label="medicine.unit_of_measurement_name"
                    />
                    <input
                      type="number"
                      v-model="devolution"
                      class="form-control"
                    />
                  </div>
                  <div v-if="show_money" class="col-md-5">
                    <LabelRequiredField label="VALOR QUE VAI PAGAR" />
                    <div class="input-group">
                      <div
                        class="
                          border
                          input-group-pprend
                          d-flex
                          align-items-center
                          justify-content-center
                          pl-3
                          pr-3
                        "
                      >
                        R$
                      </div>
                      <input
                        @input="handleChangeValue($event.target.value)"
                        type="text"
                        v-model="value"
                        class="form-control"
                      />
                    </div>
                  </div>
                  <div v-if="show_stock" class="col-md-4">
                    <LabelRequiredField label="ESTOQUE DE ENTRADA" />
                    <select
                      v-model="destination_stock_group_id"
                      class="form-control"
                    >
                      <option value="">SELECIONE...</option>
                      <option
                        v-for="stock in stock_groups"
                        :key="stock.id"
                        :value="stock.id"
                      >
                        {{ stock.name }}
                      </option>
                    </select>
                  </div>
                  <div class="col-md-12">
                    <ErrorsMessages :errors="errors" />
                    <v-btn
                      :disabled="loadingDevolution"
                      @click="
                        handleDevolution(
                          item,
                          medicine.unit_of_measurement_value
                        )
                      "
                      class="btn-save float-right"
                      ><i class="mr-1 fas fa-check"></i>
                      {{ loadingDevolution ? "CARREGANDO" : "AVANÇAR" }}</v-btn
                    >
                  </div>
                </div>
              </b-modal>
            </div>
          </div>
        </div>
      </div>
      <errors-messages :errors="errors" />
    </b-overlay>
  </div>
</template>

<script>
import ErrorsMessages from "../../../Components/ErrorsMessages";

import LabelRequiredField from "../../../Components/LabelRequiredField";

import api from "../../../../services/api";

import APIGet from "../../../../lib/api-get";

import toast from "../../../../lib/ToastNotification";

import routes from "../../../../routes";

import permission from "../../../../lib/permission";

import {
  formatValueOnKeyUp,
  formatDateMonthYear,
  formatDateToMonthYear,
} from "../../../../lib/format";

export default {
  name: "Borrewed",

  components: {
    ErrorsMessages,
    LabelRequiredField,
  },

  data() {
    return {
      origin_stock_group_id: "",
      destination_stock_group_id: "",
      origin_stocked_item_id: "",
      resident_id: "",
      stocks: [],
      stock_groups: [],
      stocked_item_lot: [],
      stocksResident: [],
      losts_stock: [],
      medicines: [],
      medicine_selected: {},
      type: "MEDICINE",
      stock_id: "",
      stock_receive_id: "",
      lot_stock_id: "",
      devolution: "",
      value: "",
      loading: false,
      loadingDevolution: false,
      loadingStock: false,
      loadingLotsStock: false,
      loadingLots: false,
      loadingStocksResident: false,
      show_money: false,
      show_stock: true,
      lot_separate: false,
      errors: [],
    };
  },

  props: {
    change_resident_id: { type: [Number, String, Boolean] },
  },

  watch: {
    change_resident_id() {
      if (this.change_resident_id) {
        this.retrieve();
      }
    },
  },

  created() {
    this.retrieve();
  },

  methods: {
    permission,
    formatValueOnKeyUp,
    formatDateMonthYear,
    formatDateToMonthYear,

    handleModalDevolution(item) {
      this.errors = [];
      this.stock_id = "";
      this.stock_receive_id = "";
      this.origin_stock_group_id = "";
      this.destination_stock_group_id = "";
      this.origin_stocked_item_id = "";
      this.stocked_item_lot = [];
      this.lot_stock_id = "";
      this.value = "";
      this.devolution = "";
      this.type = "MEDICINE";
      this.show_stock = true;
      this.show_money = false;
      this.medicine_selected = item;
      this.losts_stock = [];
      this.$bvModal.show(
        `devolution_${item.resident_id}_${item.medicine_check_id}`
      );
    },

    handleChangeValue(value) {
      this.value = formatValueOnKeyUp(value);
    },

    handleChangeType(type) {
      this.stock_id = "";
      this.lot_stock_id = "";
      this.losts_stock = [];
      this.origin_stock_group_id = "";
      this.origin_stocked_item_id = "";
      this.destination_stock_group_id = "";
      this.stocked_item_lot = [];
      this.errors = [];
      if (type == "MEDICINE") {
        this.show_money = false;
        this.show_stock = true;
        this.value = "";
      } else {
        this.show_money = true;
        this.show_stock = false;
      }
    },

    async retrieve() {
      const { id } = routes.history.current.params;

      this.resident_id = id;

      let { resident_id, medicine_id, type } = routes.history.current.query;

      await this.get();

      if (this.errors.length == 0) await this.getStockGroups();
      if (this.errors.length > 0) return;

      if (
        resident_id &&
        medicine_id &&
        type &&
        ["PADRAO", "CASA_DE_REPOUSO"].includes(type)
      ) {
        let medicines = this.medicines;

        for (let medicine of medicines) {
          for (let item of medicine.items) {
            if (item.medicine_id == medicine_id && item.medicine_type == type) {
              this.handleModalDevolution(item);
              break;
            }
          }
        }
      }
    },

    async get() {
      try {
        this.loading = true;

        let { resident_id } = this;

        let params = { resident_id };

        const response = await api.get("/rest-home/resident/stock/borrowed", {
          params,
        });

        const { error, errors, medicines } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.medicines = medicines;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async getLots() {
      try {
        this.origin_stocked_item_id = "";
        this.loadingLots = true;

        let {
          medicine_selected: { resident_id, medicine_id },
          origin_stock_group_id,
        } = this;

        let params = {
          resident_id,
          medicine_id,
          stock_group_id: origin_stock_group_id,
        };

        const response = await api.get(
          "/rest-home/resident/stock/lots-by-stock-group",
          {
            params,
          }
        );

        const { stocked_item_lot, lot_separate } = response.data;

        this.stocked_item_lot = stocked_item_lot;
        this.lot_separate = lot_separate;

        this.loadingLots = false;
      } catch (error) {
        console.log(error);
      }
    },

    async getStockGroups() {
      this.loading = true;
      let params = { type: "MEDICINE" };
      const { error, errors, stock_groups } = await APIGet.getStockGroups(
        params
      );
      this.errors = errors;
      this.stock_groups = error ? [] : stock_groups;
      this.loading = false;
    },

    async handleDevolution(medicine, unit_of_measurement_value) {
      try {
        this.loadingDevolution = true;

        let {
          resident_id,
          type,
          stock_id,
          stock_receive_id,
          origin_stock_group_id,
          origin_stocked_item_id,
          destination_stock_group_id,
          lot_stock_id,
          devolution,
          value,
        } = this;

        let params = {
          resident_id,
          type,
          stock_id,
          stock_receive_id,
          origin_stock_group_id,
          origin_stocked_item_id,
          destination_stock_group_id,
          lot_stock_id,
          devolution,
          value,
          medicine,
          unit_of_measurement_value,
        };

        const response = await api.post(
          "/rest-home/resident/devolution",
          params
        );

        const { error, errors, message } = response.data;

        if (!error) {
          toast(message, "success");
          this.$bvModal.hide(
            `devolution_${this.medicine_selected.resident_id}_${this.medicine_selected.medicine_check_id}`
          );
          this.get();
          this.errors = [];
        } else {
          this.errors = errors;
        }

        this.loadingDevolution = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
